import EditorJs from '@editorjs/editorjs';
import { KeyboardListenerParams } from '../types';
import { getCaretPosition, setCaretPosition } from '../../utils';

class InstructionSeparator {
  protected editor: EditorJs;

  constructor({ editor }: Pick<KeyboardListenerParams, 'editor'>) {
    this.editor = editor;
  }

  async process() {
    try {
      await this.getCaretPosition();
    } catch (e) {
      console.error(e);
    }
  }

  async getCaretPosition() {
    const currentBlockIndex = this.editor.blocks.getCurrentBlockIndex();
    if (currentBlockIndex !== -1) {
      const currentBlock = await this.editor.blocks.getBlockByIndex(currentBlockIndex);
      if (currentBlock && currentBlock.holder) {
        const range = getCaretPosition(currentBlock.holder);
        const currentInstructionElement = range?.endContainer?.parentNode?.parentNode as HTMLElement;
        if (range && currentInstructionElement && currentInstructionElement.classList.contains('inline-instruction-wrapper')) {
          if (currentInstructionElement.parentElement && currentInstructionElement.parentElement.classList.contains('ce-paragraph')) {
            if (!currentInstructionElement.nextSibling) {
              currentInstructionElement.parentElement.append('\u00A0');
            } else {
              currentInstructionElement.nextSibling.before('\u00A0');
            }
            await setCaretPosition(currentInstructionElement.nextSibling as HTMLElement, 1);
          }
        }
      }
    }

  }
}

export default InstructionSeparator;
